import Typography from '#components/typography/Typography';
import Button from '#components/controls/button/Button';
import React from 'react';
import IllustratedLayout from '#components/layout/IllustratedLayout';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { LivestreamState } from '#types/generated/graphql-types';

type props = {
  currentLivestreamState: LivestreamState;
};

const CountdownEndLayout = ({ currentLivestreamState }: props) => {
  const { t } = useTranslation();
  const { reload } = useRouter();

  if (
    ![LivestreamState.PreLive, LivestreamState.Upcoming].includes(
      currentLivestreamState
    )
  ) {
    return null;
  }

  return (
    <div className="tw-max-w-page tw-w-full tw-mx-auto tw-mb-8 medium-up:tw-mb-28">
      <IllustratedLayout
        title={t('CountdownEndsInfoLiveTitle')}
        image="/static/images/img/euro-maus-ls-ended.png"
        content={
          <div className="tw-flex-col">
            <Typography classes="tw-mb-8">
              {t('CountdownEndsInfoLiveText')}
            </Typography>
            <Button
              title={t('CountdownEndsInfoLiveButton')}
              color={'secondary'}
              onClick={() => reload()}
            />
          </div>
        }
      />
    </div>
  );
};

export default CountdownEndLayout;
